module.exports = __webpack_public_path__ + "img/ur3_02.bc26b4c1.jpg";